import React, { useCallback, useEffect, useState } from "react";

import { CiSearch } from "react-icons/ci";
import Select from "react-select";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import SelectedQuoteTalent from "./SelectedQuoteTalent";
import SelectedTalentsOfQuotes from "./QuoteDetails";
import Paginator from "../../components/Paginator";
import Lottie from "lottie-react";
import NoResultAnimation from "../../assets/animations/No Result Green theme.json"
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";

const Qutations = () => {
        const { t, i18n } = useTranslation();
 
  const [qutationData, setQutationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
  });

  const [filters, setFilters] = useState({
    search: "",
    pay_status: "",
    daterange: { from: null, to: null },
  });
  const [selectedTalentData, setSelectedTalentData] = useState([]);
  const [selectedTalentByProjectData, setSelectedTalentByProjectData] =
    useState([]);

  console.log("selectedTalentByProjectData - - ", selectedTalentByProjectData);
const fetchQutationDataDebounced = useCallback(
  debounce((newFilters) => {
    fetchQutationData(1, newFilters); // pass filters explicitly
  }, 500), // 500ms debounce
  []
);

 const fetchQutationData = async (page = 1, appliedFilters = filters) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);

    if (appliedFilters.search) params.append("search", appliedFilters.search);
    if (appliedFilters.pay_status) params.append("status", appliedFilters.pay_status);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // YYYY-MM-DD
    };

    if (appliedFilters.daterange.from) {
      const from = formatDate(appliedFilters.daterange.from);
      if (from) params.append("daterange[from]", from);
    }

    if (appliedFilters.daterange.to) {
      const to = formatDate(appliedFilters.daterange.to);
      if (to) params.append("daterange[to]", to);
    }
setQutationData([]);
    setIsLoading(true);
    const res = await ApiService.request({
      method: "GET",
      url: `company/getProjects?${params.toString()}`,
    });

    const data = res.data;
    if (data.status) {
      setQutationData(data?.data?.projects);
      setPagination(data?.data?.pagination ? data?.data?.pagination : 1);
    } else {
      toast.error(data.message);
    }
  } catch (err) {
    console.error("Fetch Quotation Error:", err);
    toast.error("Failed to fetch quotations.");
  } finally {
    setIsLoading(false);
  }
};


  useEffect(() => {
    fetchQutationData(1);
  }, []);
  // Status filter options
  const statusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Quoted", label: "Quoted" },
    { value: "Rejected", label: "Rejected" },
  ];

    function formatSingleDate(isoDate) {
      const date = new Date(isoDate);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "short" }); // or "long" for full month name
      return `${day} ${month}`;
    }

  function calculateDurationDetailsISO(startISO, endISO) {
    const startDate = new Date(startISO);
    const endDate = new Date(endISO);

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    const parts = [];
    if (years) parts.push(`${years} year${years > 1 ? "s" : ""}`);
    if (months) parts.push(`${months} month${months > 1 ? "s" : ""}`);
    if (days) parts.push(`${days} day${days > 1 ? "s" : ""}`);

    return parts.length ? ` ${parts.join(", ")}` : "Duration: 0 days";
  }

  const handlePageChange = (page) => {
    if (
      page !== pagination.current_page &&
      page >= 1 &&
      page <= pagination.total_pages
    ) {
      fetchQutationData(page);
    }
  };

  const { current_page, total_pages } = pagination;

  // Generate page numbers (for large datasets show 1,2,3,...,last)
  const getPages = () => {
    const pages = [];

    if (total_pages <= 5) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (current_page > 3) {
        pages.push("...");
      }
      for (
        let i = Math.max(2, current_page - 1);
        i <= Math.min(total_pages - 1, current_page + 1);
        i++
      ) {
        pages.push(i);
      }
      if (current_page < total_pages - 2) {
        pages.push("...");
      }
      pages.push(total_pages);
    }

    return pages;
  };

  const pages = getPages();

  const location = useLocation();
  const navigate = useNavigate();

  const getQueryParam = (key) => new URLSearchParams(location.search).get(key);
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    const currentTab = getQueryParam("subTab");
    if (currentTab && currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
  }, [location.search]);


    const fieldBgColor = "white"; 
  const optionHoverColor = "rgba(65, 19, 24, 0.08)"; 
const handleClearFilters = () => {
  const clearedFilters = {
    search: "",
    pay_status: "",
    daterange: { from: null, to: null },
  };

  setFilters(clearedFilters);
  fetchQutationData(1, clearedFilters); 
};  
 const isRTL = i18n.language === 'ar';


  return (
    <>
      <div className="inter-font " style={{ minHeight: "100vh" }}>
        {activeTab === "" && (
          <>
            <div className="inter-font d-flex justify-content-between align-items-center flex-wrap px-3">
              <h2 className="inter-font inter-font" style={{ fontSize: "19px" }}>
                {t("new_text_51")}
              </h2>
            </div>

            {/* Search */}
            <div className="inter-font position-relative mb-3">
                 {isRTL ?  <CiSearch
                                  className="inter-font position-absolute"
                                  style={{
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%) scaleX(-1)",
                                    pointerEvents: "none",
                                  }}
                                  size={20}
                                /> : null }
              <input
                type="text"
                placeholder={t("c_ff_text65")}
          value={filters.search}
          onChange={(e) => {
    const newFilters = { ...filters, search: e.target.value };
    setFilters(newFilters); 
    fetchQutationDataDebounced(newFilters); 
  }}
                className={`inter-font w-100 p-2 rounded-3  py-3 inter-font ${isRTL ? 'pe-5' : 'ps-5'} `}
                style={{ paddingLeft: "2.5rem", border: "none" }}
              />
             {isRTL ? null : <CiSearch
                                className="inter-font position-absolute"
                                style={{
                                  left: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  pointerEvents: "none",
                                }}
                                size={20}
                              />}
            </div>

            {/* Filters */}
   <div className="inter-font d-flex flex-wrap gap-2 align-items-center">
      {/* Status */}
      <div style={{ flex: "1 1 150px", minWidth: "150px" }}>
        <Select
          options={statusOptions}
          value={statusOptions.find((o) => o.value === filters.pay_status) || null}
          onChange={(opt) =>
            setFilters({ ...filters, pay_status: opt?.value || "" })
          }
          placeholder={t("new_text_50")}
          isClearable
          styles={{
            control: (base) => ({
              ...base,
              height: 40,
              minHeight: 40,
              fontSize: 14,
              borderRadius: 8,
              border: "none",
              boxShadow: "none",
              backgroundColor: fieldBgColor,
            }),
            valueContainer: (base) => ({ ...base, padding: "0 10px" }),
            placeholder: (base) => ({ ...base, color: "#6c757d" }),
            menu: (base) => ({ ...base, borderRadius: 8, fontSize: 14 }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused ? optionHoverColor : "white",
              color: "#212529",
              padding: "8px 10px",
              cursor: "pointer",
            }),
          }}
        />
      </div>

      {/* Date Range */}
      <div style={{ flex: "1 1 250px", minWidth: "250px" }}>
        <DateRangePicker
          initialSettings={{ minDate: moment().startOf("day") }}
          onApply={(event, picker) => {
            setFilters({
              ...filters,
              daterange: {
                from: picker.startDate.toDate(),
                to: picker.endDate.toDate(),
              },
            });
          }}
          autoUpdateInput={false}
          opens="right"
        >
          <input
            type="text"
            className="form-control"
            placeholder={t("new_text_49")}
            style={{
              height: "40px",
              fontSize: 14,
              padding: "0 10px",
              borderRadius: 8,
              border: "none",
              backgroundColor: fieldBgColor,
              boxShadow: "none",
              color: "#212529",
            }}
            value={
              filters.daterange.from && filters.daterange.to
                ? `${filters.daterange.from.toLocaleDateString()} - ${filters.daterange.to.toLocaleDateString()}`
                : ""
            }
            readOnly
          />
        </DateRangePicker>

        {/* Fix placeholder color */}
        <style jsx>{`
          .form-control::placeholder {
            color: #6c757d !important;
            opacity: 1;
          }
          .daterangepicker {
            box-shadow: none !important;
          }
        `}</style>
      </div>

      {/* Search Button */}
      <button
        className="btn d-flex align-items-center justify-content-center gap-1"
        style={{
          background: "rgba(205, 73, 109, 1)",
          color: "white",
          padding: "0 18px",
          border: "none",
          borderRadius: 8,
          height: 40,
          fontSize: 14,
        }}
        onClick={() => fetchQutationData(1)}
      >
             {isRTL ? null : <CiSearch size={18} />} 
                          {isRTL ?  <CiSearch
                                    style={{
                                      transform: " scaleX(-1)",
                                    }}
                                    size={18}
                                  /> : null } 
        {t("c_ff_text66")}
      </button>

      {/* Clear Button */}
      <button
        className="btn d-flex align-items-center justify-content-center gap-1"
        style={{
          background: "rgba(108, 117, 125, 0.9)",
          color: "white",
          padding: "0 18px",
          border: "none",
          borderRadius: 8,
          height: 40,
          fontSize: 14,
        }}
        onClick={handleClearFilters}
      >
        {t("c_ff_text67")} 
      </button>
    </div>


            {/* Table */}
            <Container className="inter-font bg-white rounded-4 mt-4 p-0 px-0 overflow-hidden">              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center py-5">
          <p className="mb-0 text-muted">Loading…</p>
        </div> ) : qutationData?.length === 0 ? (
                <div className="text-center my-4">
          <div style={{ maxWidth: 200, margin: "0 auto" }}>
            <Lottie animationData={NoResultAnimation} loop={true} />
          </div>
        </div>
              ) : (
                <div style={{overflowX: "auto", width:"100%"}}>


              <div style={{ minWidth: "786px" }}>
  {qutationData.map((item, idx) => (
    <Row
      key={idx}
      className="inter-font align-items-start py-3 px-3 border-bottom"
      style={{ 
        fontFamily: "Inter, sans-serif", 
        justifyContent: "space-between"
      }}
    >
      {/* Date Column */}
      <Col xs={2} className="inter-font mb-3 mb-md-0" style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        <div className="inter-font fw-semibold">
          {t("new_text_52")}
        </div>
        <div style={{ 
          direction: "ltr",
          unicodeBidi: "plaintext"
        }}>
          {item?.createdAt ? formatSingleDate(item?.createdAt) : "-"}
        </div>
      </Col>

      {/* Quote No Column */}
      <Col xs={2} className="inter-font mb-3 mb-md-0" style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        <div className="inter-font fw-semibold">
          {t("t_d_text98")}
        </div>
        <div style={{ 
          direction: "ltr",
          unicodeBidi: "plaintext"
        }}>
          {item.project_code}
        </div>
      </Col>

      {/* Project Title Column */}
      <Col xs={2} className="inter-font mb-3 mb-md-0" style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        <div className="inter-font fw-semibold">
          {t("t_d_text95")}
        </div>
        <div style={{ 
          direction: "ltr",
          unicodeBidi: "plaintext"
        }}>
          {item.title}
        </div>
      </Col>

      {/* Amount Column */}
      <Col xs={2} className="inter-font mb-3 mb-md-0" style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        <div className="inter-font fw-semibold">
          {t("t_d_text85")}
        </div>
        <div style={{ 
          fontSize: "14px", 
          color: "#999", 
          direction: "ltr",
          unicodeBidi: "plaintext"
        }} >
          {item.total_amount} AED
        </div>
      </Col>

      {/* Status Column */}
      <Col xs={2} style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        <div className="inter-font fw-semibold">
          {t("t_d_text83")}
        </div>
        <div className="inter-font d-flex flex-wrap align-items-center gap-2 mt-2 inter-font">
          <span
            style={{
              background:
                item.status === "Accepted"
                  ? "#00C25F"
                  : item.status === "Pending"
                  ? "#F9C74F"
                  : "#CC496D",
              fontWeight: 500,
              padding: "5px",
              height: "22px",
              fontSize: "10px",
              color: "white",
              borderRadius: "4px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              direction: "ltr",
              unicodeBidi: "plaintext"
            }}
          >
            {item.status}
          </span>
        </div>
      </Col>

      {/* Actions Column */}
      <Col xs="auto" style={{ 
        textAlign: isRTL ? "right" : "left",
        direction: isRTL ? "rtl" : "ltr"
      }}>
        <div className="inter-font d-flex flex-wrap align-items-center gap-2 mt-2" style={{ 
          justifyContent: isRTL ? "flex-end" : "flex-start"
        }}>
          <button className="btn btn-light "
              onClick={() => {
                  navigate("/company/quote-details/", {
                    state: { talentData: item }
                  });
                  setSelectedTalentData(item);
              }}>
            <FaEye
              fontSize={18}
              style={{ cursor: "pointer", color: "gray" }}
            /> Details
          </button>
        </div>
      </Col>
    </Row>
  ))}
</div>
                </div>
              )}
            </Container>

         {/* Pagination */}
         {pagination?.total_pages > 1 && (
                <Paginator
                    page={pagination.current_page}
                    rows={pagination.per_page}
                    totalRecords={pagination.total_records}
                    onPageChange={handlePageChange}
                />
               
            )}
          </>
        )}

        {activeTab === "selectedOuoteTalent" && (
          <SelectedQuoteTalent
            selectedTalent={selectedTalentData}
            setSelectedTalentByProjectData={setSelectedTalentByProjectData}
          />
        )}

        {activeTab === "selectedTalentsOfQuotes" && (
          <SelectedTalentsOfQuotes
            selectedTalentData={selectedTalentData}
            selectedTalentByProjectData={selectedTalentByProjectData}
          />
        )}

        {/* Footer */}
      </div>
    </>
  );
};

export default Qutations;
